import type { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type { ColorScheme }

const lightTokens = {
  textColor: 'light.text.primary',
  borderColor: 'light.interactive.tertiary-border',
  hoverBorderColor: 'light.interactive.tertiary-hover-border',
  activeBg: 'light.interactive.tertiary-active-bg',
  activeBorderColor: 'light.interactive.tertiary-active-border',
  activeTextColor: 'light.interactive.tertiary-active-text',
  focusRing: 'light.interactive.focus-ring',
}

const darkTokens = {
  textColor: 'text.primary',
  borderColor: 'interactive.tertiary-border',
  hoverBorderColor: 'interactive.tertiary-hover-border',
  activeBg: 'interactive.tertiary-active-bg',
  activeBorderColor: 'interactive.tertiary-active-border',
  activeTextColor: 'interactive.tertiary-active-text',
  focusRing: 'interactive.focus-ring',
}

export const workflowButtonStyles = (
  colorScheme: ColorScheme = 'light',
  disabled = false,
  isActive = false
): SystemStyleObject => {
  const t = colorScheme === 'light' ? lightTokens : darkTokens
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px',
    gap: '8px',
    background: isActive ? t.activeBg : 'none',
    border: '1px solid',
    borderColor: isActive ? t.activeBorderColor : t.borderColor,
    borderRadius: '0',
    px: '16px',
    py: '12px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    color: isActive ? t.activeTextColor : t.textColor,
    fontFamily: "'Soehne Kraftig', 'Söhne Kräftig', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    opacity: disabled ? 0.35 : 1,
    transition: 'border-color 0.15s ease, background 0.15s ease',
    _hover: disabled || isActive ? {} : { borderColor: t.hoverBorderColor },
    _active: disabled
      ? {}
      : {
          bg: t.activeBg,
          borderColor: t.activeBorderColor,
          color: t.activeTextColor,
        },
    _focusVisible: {
      outline: '2px solid',
      outlineColor: t.focusRing,
      outlineOffset: '2px',
    },
  }
}
